module.exports = __webpack_public_path__ + "static/img/p18.bbfe6de8.png";